// extracted by mini-css-extract-plugin
export default {"successButton":"SuccessButton_successButton_XR_s3","successButton__loader":"SuccessButton_successButton__loader_VM9sA"};